import { Component, OnInit, Input } from '@angular/core';
import { StoreCommonService } from '../../../../services/store/store-common.service';
import { ServiceStoreList } from '../../../../models/service.model';
import { Router } from '@angular/router';
import { ServiceStoreService } from '../../../../services/service/service-store.service';
import { KonPermission } from 'app/modules/UIKit/components/kontable/utility/utility-model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-store-common-services',
  templateUrl: './store-common-services.component.html',
  styleUrls: ['./store-common-services.component.css'],
  providers: []
})
export class StoreCommonServicesComponent implements OnInit {

  @Input() editMode: boolean;
  @Input() storeId: any;

  public showDialog = false;
  public serviceList: ServiceStoreList[] = [];
  public newDataAvailable = false;
  public perm: KonPermission = new KonPermission();
  addServiceTitle: string;

  constructor (
    private router: Router,
    private storeServiceSrv: ServiceStoreService,
    private storeSrv: StoreCommonService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.refresh();

    this.translate.get([
      'calendarList.add_title',
    ]).subscribe((res) => {
      this.addServiceTitle = res['calendarList.add_title'];
    });

    this.perm.edit = false;
    this.perm.view = false;
  }

  refresh() {
    setTimeout(() => {
      this.storeSrv.getServiceList(this.storeId).subscribe(services => {
        this.serviceList = services;
        this.newDataAvailable = true;
      });
    }, 200);
  }

  deleteServiceStore(serviceStore: ServiceStoreList) {
    this.storeServiceSrv.delete(serviceStore.id).subscribe(() => {
      this.refresh();
    });
  }

  onDialogHide () {
    this.showDialog = false;
    this.refresh();
  }

  showAddService () {
    this.showDialog = true;
  }

  onAddElement (element) {
    this.showDialog = false;
    this.refresh();
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-common-services/store-common-services.component.ts